<template>
    <div class="BranchListPage">
        <zPage :contentState="pageContentState">
            <template v-slot:headerTitle>{{ gettext('Продвижение на картах - модуль Local Pack') }}</template>
            <template v-slot:headerDescription> {{ gettext('Инструмент оценки результатов продвижения карточек компании на картах.') }}
                <a @click="openModal1"
                   class="a-button a-button--link a-button--action">{{ gettext('Подробнее') }}</a>
            </template>


            <template v-slot:topBar>
                <div class="buttonGroup">
                    <button class="button" v-on:click="chooseTab('branches')" v-bind:class="{'--active': isBranchesTab}">{{ gettext('по филиалам') }}
                    </button>
                    <button class="button" v-on:click="chooseTab('keywords')" v-bind:class="{'--active': isKeywordsTab}">{{ gettext('по ключевикам') }}
                    </button>
                </div>

                <div style="margin-left: 100px">
                    <router-link :to="{ name: 'KeywordsManagement' }">
                        <button class="button button--primary">{{ gettext('Управление ключевиками') }}</button>
                    </router-link>
                </div>
            </template>

            <template v-slot:main>
                <zPaginator ref="paginator"
                            :paginator="paginator"
                            :pending="domains.branches.query.pending"
                            @changePage="changePage"
                            @changePageSize="changePageSize">
                    <div>
                        <div class="xCard"
                             v-for="branch in branches" :key="branch.name"
                             style="overflow: hidden">
                            <div class="xCard__body" style="display: flex; align-items: center;">
                                <Tooltip content="Посмотреть статистику по филиалу" placement="bottom-start">
                                    <div class="__title" @click="chooseBranch(branch.id)">{{
                                            branch.name
                                        }}
                                    </div>
                                </Tooltip>
                                <div class="__description">{{ branch.address }}</div>
                            </div>
                        </div>
                    </div>
                </zPaginator>
            </template>
        </zPage>

        <!--    <pre style="margin-top: 30px; padding: 20px; background: #fafafa">{{ domains.branches.query | prettyJson }}</pre>-->

        <Modal v-model="modal1"
                :title="gettext('Информация о разделе')"
                footer-hide>
            <div class="about-repometr">
                <div class="info-block info-block--flat" style="margin-bottom: 0">
                    <div class="info-block__title">{{ gettext('Что такое LocalPack и как его использовать для привлечения клиентов?') }}</div>
                    <div class="info-block__body">
                        <p>{{ gettext('Клиенты приходят к вам, когда находят карточку компании по ключевым запросам. В блоке карт результатов поисковой выдачи отображаются карточки филиалов вашей компании и карточки конкурентов.') }}
                        </p>
                    </div>
                </div>

                <img src="/static/images/local-pack/localpack_branches_info_1.png">

                <div class="promo-block">{{ gettext('Для получения максимального числа обращений клиентов важно быть выше конкурентов в результатах поиска.') }}</div>

                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Основные факторы, которые влияют на позиции карточек филиалов:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('рейтинг филиала;') }}</li>
                            <li>{{ gettext('работа с отзывами - новые отзывы с ответами оцениваются выше, уровень профиля пользователя, оставившего отзыв (например, “местный эксперт 8 уровня”), оценки клиентов;') }}</li>
                            <li>{{ gettext('наличие ключевых слов поисковых запросов в описании компании, текстах отзыва и ответов;') }}</li>
                            <li>{{ gettext('полнота данных профиля - заполнены категории, адресные данные, добавлены фотографии;') }}</li>
                            <li>{{ gettext('регулярное обновление и актуализация данных;') }}</li>
                            <li>{{ gettext('внешние ссылки на карточку филиала (требует участия SEO-специалиста).') }}</li>
                        </ul>
                    </div>
                </div>
                
                <div class="info-block">
                    <div class="info-block__title">{{ gettext('Работать над улучшением этих факторов можно в интерфейсе и сервисах Repometr в разделах:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('Отзывы') }}</li>
                            <li>{{ gettext('Филиалы') }}</li>
                            <li>{{ gettext('Мониторинг') }}</li>
                            <li>{{ gettext('Работа с клиентами') }}</li>
                        </ul>
                    </div>
                </div>

                <div class="info-block info-block--promo" :hidden=isDemoPage>
                    <div v-if="aboutRepometrFormResponse">
                        <span class="form-response">{{ aboutRepometrFormResponse.message }}</span>
                    </div>
                    <div v-else>
                        <div class="info-block__title">
                            {{ gettext('Или можно доверить продвижение карточек филиалов нашей профессиональной команде. Для этого отправьте заявку.') }}
                        </div>
                        <div class="info-block__body">
                            <form>
                                <div class="form-field">
                                    <div class="form-field__title">{{ gettext('Как к Вам обращаться?') }}</div>
                                    <Input v-model="aboutRepometrForm.name"
                                           type="text"
                                           name="name"
                                           placeholder="Имя"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <div class="form-field__title">{{ gettext('Укажите номер телефона или e-mail') }}</div>
                                    <Input v-model="aboutRepometrForm.phone"
                                           type="text"
                                           name="phone"
                                           placeholder="Телефон"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <Input v-model="aboutRepometrForm.email"
                                           type="text"
                                           name="email"
                                           placeholder="E-mail"
                                           style="min-width: 300px"
                                           :disabled="false"/>
                                </div>
                                <div class="form-field">
                                    <button class="button button--primary"
                                            @click.prevent="createHelpRequest">{{ gettext('Отправить') }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>


<script>
import {baseUrl} from "@/1_webapi/api";
import {makeBaseComponent} from "@/2_app-logic/models";
import zPage from "@/3_view/core/zPage";
import zPaginator from "@/3_view/core/zPaginator";
import {api} from "@/main";
import { createNamespacedHelpers } from 'vuex';


const { mapState, mapGetters, mapActions } = createNamespacedHelpers('BranchList');

export default {
    name: 'BranchList',
    components: {
        zPage,
        zPaginator,
    },
    props: {
        isDemoPage: Boolean
    },
    extends: makeBaseComponent({ mapState, mapGetters, mapActions }),
    data: () => ({
        modal1: false,
        aboutRepometrForm: {
            name: '',
            phone: '',
            email: '',
        },
        aboutRepometrFormResponse: null,
    }),
    computed: {
        ...mapState([
            'domains',
        ]),
        ...mapGetters([
            'paginator',
            'branches',
        ]),
        baseUrl() {
          return baseUrl()
        },
        isInitDataReady() {
            return !!(this.paginator && this.branches.length)
        },
        currentTab() {
            return this.$store.getters.currentTab
        },
        isBranchesTab() {
            return this.currentTab === 'branches'
        },
        isKeywordsTab() {
            return this.currentTab === 'keywords'
        },
        pageContentState() {
            return {
                pending: this.domains.branches.query.pending,
                isInitDataReady: this.isInitDataReady,
                notExistText: this.gettext('Список филиалов пуст'),
            }
        }
    },
    methods: {
        ...mapActions([
            'fetchBranches',
        ]),
        async getList() {
            await this.fetchBranches()
        },
        chooseBranch(id) {
            this.$router.push({ name: 'RankByBranch', params: {id} })
        },
        chooseTab(value) {
            this.$store.dispatch('setCurrentTab', value)

            if (this.isBranchesTab) {
                this.$router.push({ name: 'BranchList' })
            }
            else if (this.isKeywordsTab) {
                this.$router.push({ name: 'KeywordList' })
            }
        },
        async openModal1() {
            this.modal1 = true
            if (!this.isDemoPage) {
                getUserDataAndFillInputs()
            }

            async function getUserDataAndFillInputs() {
                const data = await api.aboutRepometrHelpForm.getUserFormData()

                const inputs = document.querySelectorAll('.about-repometr form input')
                inputs.forEach(input => {
                    const value = data[input.name]
                    input.value = value ? value : ''
                })
            }
        },
        async createHelpRequest() {
            const data = await api.aboutRepometrHelpForm.createHelpRequest({ ...getFormValues()})
            this.aboutRepometrFormResponse = data
            function getFormValues() {
                const inputs = document.querySelectorAll('.about-repometr form input')
                const values = {}
                inputs.forEach(input => {
                    values[input.name] = input.value
                })
                return values
            }
        }
    },
    
    async mounted() {
        await this.getList()
    },
}
</script>

<style lang="less">

</style>